import {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
} from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_CLIENT_INSURANCE_INFO } from "../queries/insurancePlans";
import { useSelector, useDispatch } from "react-redux";
import { enqueueSnackbar } from "../state/ducks/notifiers";
const InsurancePlansContext = createContext();

export const InsurancePlansProvider = ({ children }) => {
  const clientId = useSelector((state) => state.auth.clientId);
  const authenticated = useSelector((state) => state.auth.authenticated);
  const dispatch = useDispatch();
  const [getInsurancePlansQuery] = useLazyQuery(GET_CLIENT_INSURANCE_INFO, {
    variables: {
      clientId: clientId,
    },
    onCompleted: (data) => {
      const formattedInsurancePlans = data?.insurancePlans?.map((plan) => ({
        label: plan?.name,
        value: plan?.name,
      }));
      setInsurancePlans(formattedInsurancePlans || []);
    },
    onError: (error) => {
      dispatch(
        enqueueSnackbar({
          message: "Error fetching insurance plans",
          options: { variant: "error" },
        })
      );
      console.error("Error fetching insurance plans:", error);
    },
  });

  const getInsurancePlans = useCallback(() => {
    getInsurancePlansQuery();
  }, [getInsurancePlansQuery]);
  const [insurancePlans, setInsurancePlans] = useState([]);

  useEffect(() => {
    if (!insurancePlans.length && authenticated) {
      getInsurancePlans();
    }
  }, [getInsurancePlans, authenticated, insurancePlans.length]);

  const contextValue = useMemo(
    () => ({ insurancePlans, getInsurancePlans }),
    [insurancePlans, getInsurancePlans]
  );

  return (
    <InsurancePlansContext.Provider value={contextValue}>
      {children}
    </InsurancePlansContext.Provider>
  );
};

export default InsurancePlansContext;

export const useInsurancePlans = () => {
  return useContext(InsurancePlansContext);
};
